import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledProAuctoreAndProFamiliaMissingContactDetailsForm = styled(StyledFlex)`
   padding-bottom: 15px;
`;
